"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const PenDraw_1 = __importDefault(require("../PenDraw"));
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
function Pen2D({ type, size = 1, color = '', opacity = 1 }) {
    const windowSize = (0, ui_1.useScreenSize)();
    const toolsService = (0, providers_1.useToolsService)();
    const canvasRef = (0, react_1.useRef)(null);
    const penToolManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getPenToolManager();
    const curves = (0, hooks_1.usePen2DCurve)();
    const canvasScreenshot = penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.getCanvasForScreenshot();
    (0, react_1.useEffect)(() => {
        if (!!canvasRef.current) {
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvas(canvasRef.current);
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvasForScreenshot(canvasRef.current);
        }
        if (canvasRef.current !== canvasScreenshot) {
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvasForScreenshot(canvasRef.current);
        }
        return () => {
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvas(null);
        };
    }, [penToolManager, canvasScreenshot]);
    (0, react_1.useEffect)(() => {
        if (canvasRef.current) {
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvasForScreenshot(canvasRef.current);
        }
        if (curves.length === 0) {
            penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.setCanvasForScreenshot(null);
        }
    }, [curves, penToolManager]);
    const onPaintEnd = (newCurves) => {
        penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.update2DPenState(newCurves);
        penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.updateUndoRedoHistory();
    };
    const setCurvesWrapper = (curvesUpdate) => {
        let newCurves;
        if (typeof curvesUpdate === 'function') {
            newCurves = curvesUpdate(curves);
        }
        else {
            newCurves = curvesUpdate;
        }
        penToolManager === null || penToolManager === void 0 ? void 0 : penToolManager.update2DPenState(newCurves);
    };
    const isCanDraw = type === bridge_schema_1.ToolType.Pen2D;
    if (curves.length === 0 && !isCanDraw) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(StyledPenDrawPanel, { ref: canvasRef, editable: isCanDraw, curves: curves, width: windowSize.width, height: windowSize.height, color: color, size: size, opacity: opacity, drawable: isCanDraw, drawOutside: false, onPaintEnd: onPaintEnd, setCurves: setCurvesWrapper, "data-e2e": 'Pen2D_StyledPenDrawPanel' }));
}
exports.default = Pen2D;
const StyledPenDrawPanel = (0, styled_components_1.default)(PenDraw_1.default) `
  pointer-events: ${({ editable }) => (editable ? 'auto' : 'none')};
`;
